import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

// Sprint-10 Phase C — cookie-only auth. The browser attaches the
// HttpOnly `access_token` cookie automatically because of withCredentials.
// We deliberately do NOT read a bearer token from localStorage anymore —
// keeping a JS-readable token defeats the point of an HttpOnly cookie
// (any XSS payload could exfiltrate it). The backend still accepts a
// Bearer header for pytest / scripted clients, but no browser code path
// uses one.
export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
}
